// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectAffiliationsInStore,
  selectAffiliationsPageLoading,
  selectAffiliationsShowInitWaitingMessage,
} from '../_selectors/affiliation.selectors';

export class AffiliationsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectAffiliationsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectAffiliationsShowInitWaitingMessage));

    this.store.pipe(select(selectAffiliationsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
